import axios from "axios";
import consts from "./constant";
import { isTemporaryAuthBypassEnabled } from "./lib/authSession";

const Axios = axios.create({
  baseURL: consts.BackendUrl,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Content-Type, Authorization",
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
});

Axios.interceptors.request.use(
  (config) => {
    if (typeof window !== "undefined") {
      const token = window.localStorage.getItem("olympusMons");
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
        config.headers.token = token;
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      typeof error.response.data === "string" &&
      error.response.data.trim() === "Unauthorized"
    ) {
      if (typeof window !== "undefined" && !isTemporaryAuthBypassEnabled()) {
        window.localStorage.clear();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default Axios;
